<template>
  <v-card>
    <v-card-title>
      <v-row
        align="center"
        justify="space-between"
        class="ma-0"
      >
        <v-flex
          class="d-flex flex-column"
        >
          <v-row
            class="ma-0"
          >
            <span class="title font-weight-regular">#{{order["id_flight_order"]}}</span> <span class="ml-2 title">{{order["nm_flight_order"]}}</span>
          </v-row>
        </v-flex>
        <v-rating
          :value="order['fl_evaluation']"
          large
          color="yellow darken-3"
          background-color="grey darken-1"
          empty-icon="$ratingFull"
          half-increments
          hover
          readonly
        ></v-rating>
      </v-row>
    </v-card-title>
    <v-card-subtitle>
      {{orderFormattedDate}}
    </v-card-subtitle>
    <v-container
      fluid
      class="pa-0"
    >
      <v-row
        class="ma-0"
      >
        <div :id="`map-${order['id_flight_order']}`" class="map"/>
      </v-row>
    </v-container>
    <v-row
      align="center"
      justify="start"
      class="mx-2 mt-4"
    >
      <v-col
        cols="12"
        class="pa-0 text-break text-left"
      >
        <v-icon
          class="ml-2"
          size="30"
          :color="orderStatusIconColor"
        >{{ orderStatusIcon}}
        </v-icon>
        <span
          class="body-3 grey--text text--darken-2 font-weight-bold text-uppercase ml-2 "> {{ orderStatusText }}</span>

      </v-col>
    </v-row>
    <v-expansion-panels
      v-model="panel"
      flat
      multiple

    >
      <v-expansion-panel>
        <v-expansion-panel-header
          class="px-4 pb-2"
        >
          <span
            class="subtitle-3 grey--text text--darken-2 font-weight-bold text-uppercase">Principais informações</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-container
            fluid
            class="pa-0"
          >
            <v-row
              align="center"
              class="ma-0"
            >
              <v-col
                cols="4"
                class="pt-1"
              >
                <span class="font-weight-bold">Data inicial</span>
                <p>{{order["dt_min_due_order"] | dateDisplay}}</p>
              </v-col>
              <v-col
                cols="4"
                class="pt-1"
              >
                <span class="font-weight-bold">Data limite</span>
                <p>{{order["dt_max_due_order"] | dateDisplay}}</p>
              </v-col>
              <v-col
                cols="4"
                class="pt-1"
              >
                <span class="font-weight-bold">Valor</span>
                <p class="font-weight-bold"><span class="font-weight-bold">R$ </span>{{order["fl_price"] |
                  toFixedWithComma}}</p>
              </v-col>
            </v-row>
            <v-row
              class="ma-0"
            >
              <v-col
                cols="12"
                class="pt-1"
              >
                <span class="font-weight-bold">Descrição</span>
                <v-textarea
                  flat
                  solo
                  outlined
                  readonly
                  no-resize
                  hide-details
                  :value="order['str_description']"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel class="py-0 my-0">
        <v-expansion-panel-header
          class="px-4 py-0"
        >
          <span class="subtitle-3 grey--text text--darken-2 font-weight-bold text-uppercase">Processamentos</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div
            v-for="flightOrderProcessing in flightOrderProcessingList"
            :key="flightOrderProcessing['cd_processing']"
          >
            <flight-order-processing-item
              :flight-order-processing="flightOrderProcessing"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-card-actions class="px-2 pb-4">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            v-on="{...tooltip}"
            :disabled="orderStatusDisableCreateProcessingButton"
            @click="createFlightOrderProcessing"
          >
            <v-icon>mdi-plus-circle</v-icon>
          </v-btn>
        </template>
        <span>Criar processamento na ordem de serviço</span>
      </v-tooltip>

      <flight-order-download-dialog
        :order="order"
      >
        <template v-slot:activator="{ on: dialog }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                v-on="{...dialog, ...tooltip}"
                icon
                color="primary"
                class="mr-2"
                :disabled="orderStatusDisableDownloadButton"
              >
                <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
            </template>
            <span>Download de arquivos da ordem de serviço</span>
          </v-tooltip>
        </template>
      </flight-order-download-dialog>
      <flight-order-attachments-dialog
        :id-order="parseInt(order['id_flight_order'])"
      >
        <template v-slot:activator="{ on: dialog }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                icon
                v-on="{...dialog, ...tooltip}"
                color="primary"
                :disabled="orderStatusDisableAttachButton"
              >
                <v-icon>mdi-paperclip</v-icon>
              </v-btn>
            </template>
            <span>Anexar arquivos na ordem de serviço</span>
          </v-tooltip>

        </template>
      </flight-order-attachments-dialog>
      <v-spacer/>
      <v-btn
        color="success"
        outlined
        :loading="isLoading"
        :disabled="orderStatusDisableActionButton"
        @click="onActionButtonClick"
      >
        {{ orderStatusButtonText }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import moment from "moment"
  import {acceptOrder, submitOrder} from "../../api/api-flight-provider"
  import {createFlightOrderProcessing} from "../../api/api-project"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"
  import {find} from "lodash/collection"
  import L from "leaflet"
  import "leaflet/dist/leaflet.css"
  import {forEach} from "lodash/collection"
  import FlightOrderProcessingItem from "./FlightOrderProcessingItem"
  import FlightOrderAttachmentsDialog from "./FlightOrderAttachmentsDialog"
  import FlightOrderDownloadDialog from "./FlightOrderDownloadDialog"
  import {ORDERS_STATUS, ORDERS_STATUS_DETAILS} from "../../helpers/flight-provider/constants"
  import {isEqual} from "lodash"

  export default {
    name: 'FlightOrderCard',
    components: {
      FlightOrderProcessingItem,
      FlightOrderDownloadDialog,
      FlightOrderAttachmentsDialog,
    },
    props: {
      order: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      isLoading: false,
      map: null,
      geoJsonList: [],
      flightOrderProcessingList: [],
      processing: null,
      panel: [],
      orderFormattedDate: null,
    }),
    methods: {
      startMap() {
        if (this.map) this.map.remove()
        this.map = L.map(`map-${this.order['id_flight_order']}`, {})
        L.tileLayer("https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}", {
          attribution: "Map data: &copy; Google Maps",
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
          maxZoom: 21,
          minZoom: 2,
          tms: false,
          label: "Google Maps Hybrid",
        })
          .addTo(this.map)
        forEach(this.order['flight_order_fields'], field => {
          this.geoJsonList.push(L.geoJSON(JSON.parse(field["geo_field"]), {}).addTo(this.map))
        })
        let bounds = null
        forEach(this.geoJsonList, item => {
          if (!bounds) bounds = item.getBounds()
          else bounds = bounds.extend(item.getBounds())
        })
        this.map.fitBounds(bounds)
      },
      createFlightOrderProcessing() {
        let flightOrderProcessingData = {
          "cd_flight_order": this.order["id_flight_order"]
        }
        createFlightOrderProcessing(this.$apiAuth.getAuthToken(), flightOrderProcessingData)
          .then((resp) => {
            this.$notify(new NotificationOptions({
              message: "Processamento criado com sucesso.",
              type: NOTIFICATION_TYPES.SUCCESS,
            }))

            let newFlightOrderProcessing = {
              "cd_processing": resp.data.data.id_processing,
            }

            this.flightOrderProcessingList.unshift(newFlightOrderProcessing)

            this.panel = [1]
          })
          .catch(() => {
            this.$notify(new NotificationOptions({
              message: "Não foi possível criar processamento.",
              type: NOTIFICATION_TYPES.ERROR,
            }))

          })
      },
      onActionButtonClick() {
        this.isLoading = true

        if (isEqual(this.order["ab_status"], ORDERS_STATUS.CREATED)) {
          acceptOrder(this.$apiAuth.getAuthToken(), this.order["id_flight_order"])
            .then(res => {
              const acceptedOrder = res.data.data
              this.$notify(new NotificationOptions({
                message: "Ordem aceita com sucesso!",
                type: NOTIFICATION_TYPES.SUCCESS,
              }))
              this.$emit("change", acceptedOrder)
            })
            .catch(() => {
              this.$notify(new NotificationOptions({
                message: "Não foi possível aceitar a ordem. Por favor entre em contato com a REDE.",
                type: NOTIFICATION_TYPES.ERROR,
              }))
            })
            .finally(() => {
              this.isLoading = false
            })
        }

        else if (isEqual(this.order["ab_status"], ORDERS_STATUS.ACCEPTED)) {
          submitOrder(this.$apiAuth.getAuthToken(), this.order["id_flight_order"])
          .then(res => {
              const submitedOrder = res.data.data
              this.$notify(new NotificationOptions({
                message: "Ordem finalizada com sucesso!",
                type: NOTIFICATION_TYPES.SUCCESS,
              }))
              this.$emit("change", submitedOrder)
            })
            .catch(() => {
              this.$notify(new NotificationOptions({
                message: "Não foi possível finalizar ordem. Por favor entre em contato com a REDE.",
                type: NOTIFICATION_TYPES.ERROR,
              }))
            })
            .finally(() => {
              this.isLoading = false
            })
        }
      },
    },
    computed: {
      orderStatusIcon() {
        return find(ORDERS_STATUS_DETAILS, ["status", this.order["ab_status"]]).icon
      },
      orderStatusIconColor() {
        return find(ORDERS_STATUS_DETAILS, ["status", this.order["ab_status"]]).color
      },
      orderStatusText() {
        return find(ORDERS_STATUS_DETAILS, ["status", this.order["ab_status"]]).text
      },
      orderStatusButtonText() {
        return find(ORDERS_STATUS_DETAILS, ["status", this.order["ab_status"]]).buttonText
      },
      orderStatusDisableActionButton() {
        return find(ORDERS_STATUS_DETAILS, ["status", this.order["ab_status"]]).disableActionButton
      },
      orderStatusDisableCreateProcessingButton() {
        return find(ORDERS_STATUS_DETAILS, ["status", this.order["ab_status"]]).disableCreateProcessingButton
      },
      orderStatusDisableDownloadButton() {
        return find(ORDERS_STATUS_DETAILS, ["status", this.order["ab_status"]]).disableDownloadButton
      },
      orderStatusDisableAttachButton() {
        return find(ORDERS_STATUS_DETAILS, ["status", this.order["ab_status"]]).disableAttachButton
      },
    },
    mounted() {
      this.orderFormattedDate = moment(this.order['dh_created']).format('DD/MM/YYYY')

      this.flightOrderProcessingList = this.order["flight_order_processings"]

      setTimeout(() => {
        this.startMap()
      }, 3000)
    },
    filters: {
      toFixedWithComma(value) {
        return value.toFixed(2).replace(".", ",")
      },
      dateDisplay(value) {
        return moment(value).format("DD/MM/YYYY")
      }
    },

  }
</script>
<style scoped lang="scss">
  .map {
    z-index: 1;
    width: 100%;
    height: 300px;
  }

  .v-rating {
    ::v-deep .v-icon {
      padding: 2px;
      font-size: 24px !important;
      width: 24px !important;
      height: 24px !important;
    }
  }

</style>
